import { ConversationFullscreenToggleButton } from "@circle-react-shared/AiConversation/header/ConversationFullscreenToggleButton";
import { useShallow } from "zustand/react/shallow";

import { DOM_IDS } from "./Layout/defaults";
import { useCircleAIShellStore } from "./store/circleAIShellStore";

export const ConversationPanelFullscreenButton = () => {
  const { conversationPanelState, setConversationPanelState } =
    useCircleAIShellStore(
      useShallow(s => ({
        conversationPanelState: s.conversationPanelState,
        setConversationPanelState: s.setConversationPanelState,
      })),
    );
  const isFullscreen = conversationPanelState === "fullscreen";

  return (
    <ConversationFullscreenToggleButton
      data-testid="circle-ai-shell-conversation-panel-fullscreen"
      isFullscreen={isFullscreen}
      onToggle={() =>
        setConversationPanelState(isFullscreen ? "default" : "fullscreen")
      }
      aria-controls={DOM_IDS.conversationPanelBody}
    />
  );
};

ConversationPanelFullscreenButton.displayName =
  "CircleAIAppShell.ConversationPanelFullscreenButton";
